// Whole years old today, from a "YYYY-MM-DD" date field value.
export function ageFrom(iso: string) {
  const [y, m, d] = iso.split("-").map(Number);
  const today = new Date();
  let age = today.getFullYear() - y;
  const month = today.getMonth() + 1;
  if (month < m || (month === m && today.getDate() < d)) age--;
  return age;
}

export function isMinorOn(iso: string | null | undefined) {
  return iso ? ageFrom(iso) < 18 : false;
}
